import {
  TTextEyebrowChildTag,
  TTextEyebrowTag,
} from "@/ui/components/typography/TextEyebrow/TextEyebrow.config";

export const getTextEyebrowChildElementTag = (eyebrowTag: TTextEyebrowTag): TTextEyebrowChildTag => {
  const ELEMENT_MAP: Record<TTextEyebrowTag, TTextEyebrowChildTag> = {
    h1: "h2",
    h2: "h3",
    h3: "h4",
    h4: "h5",
    h5: "h6",
  };

  return ELEMENT_MAP[eyebrowTag];
};
